import { pipe } from 'fp-ts/lib/function';
import { chain } from 'fp-ts/lib/TaskEither';
import { listCodec } from './codec';
import {
  createAuthorizedGetRequest,
  decode,
  fetchApi,
} from '../..';

const baseUrl = (entityTypeId: number): string => `/v2/entity-types/${entityTypeId}/properties`;

export const list = (entityTypeId: number) => pipe(
  baseUrl(entityTypeId),
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(listCodec)),
);
